// verification_act
export const ROAMING_VERIFICATION_ACT_SYNC_REQUESTED = 'ROAMING_VERIFICATION_ACT_SYNC_REQUESTED';
export const ROAMING_VERIFICATION_ACT_SYNC_SUCCESS = 'ROAMING_VERIFICATION_ACT_SYNC_SUCCESS';
export const ROAMING_VERIFICATION_ACT_SYNC_FAILED = 'ROAMING_VERIFICATION_ACT_SYNC_FAILED';